import setting from '@/setting'

import { useAmountUtil } from './amount'
import { useCalculationUtil } from './calculation'
import { useCookiesUtil } from './cookies'
import { useDbUtil } from './db'
import { useFileUtil } from './file'
import { useInitUtil } from './init'
import { useResponseUtil } from './response'
import { useSortUtil } from './sort'
import { useTableUtil } from './table'
import { useValidateUtil } from './validate'
import { isExpired } from '@/api/quality/order'
import store from '@/store'
import dayjs from 'dayjs'

const util = {
  amount: useAmountUtil,
  calculation: useCalculationUtil,
  cookies: useCookiesUtil,
  db: useDbUtil,
  file: useFileUtil,
  init: useInitUtil.init,
  response: useResponseUtil,
  sort: useSortUtil,
  table: useTableUtil,
  validate: useValidateUtil
}

/**
 * 更新标题
 */
util.title = function(titleText) {
  window.document.title = `${process.env.VUE_APP_TITLE}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * 打开新页面
 */
util.open = function(url) {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', `${setting.name}-link-temp`)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById(`${setting.name}-link-temp`))
}

/**
 * 是否过期
 */
util.isExpired = async function() {
  const res = await isExpired()
  const effectiveTime = dayjs(res.effectiveTime)
  const currentDate = dayjs(res.currentDate)
  if (store.state.user.info.effectiveTime !== res.effectiveTime) {
    await store.dispatch('user/saveUserExpiredInfo', {
      effectiveTime: res.effectiveTime,
      currentTime: res.currentDate
    })
  }
  return effectiveTime.diff(currentDate, 'day') < 0
}

export default util
